customElements.get("product-model") ||
  customElements.define(
    "product-model",
    class extends DeferredMedia {
      constructor() {
        super();
      }
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(e) {
        if (!e) {
          this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer"),
          );
          let o = this,
            i = o.querySelector("model-viewer");
          new MutationObserver((e) => {
            null != o.closest(".swiper") &&
              (i.classList.contains("shopify-model-viewer-ui__disabled")
                ? (o.closest(".swiper").swiper.params.noSwiping = !1)
                : ((o.closest(".swiper").swiper.params.noSwiping = !0),
                  (o.closest(".swiper").swiper.params.noSwipingClass =
                    "swiper-slide")));
          }).observe(i, { attributes: !0 });
        }
      }
    },
  ),
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      e ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((e) => {
              window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR(),
            ));
    },
  }),
  window.addEventListener("DOMContentLoaded", () => {
    window.ProductModel?.loadShopifyXR();
  });
